import { DateTime } from "luxon";

import { IStockCheckReportItem } from "../models/stockCheck/IStockCheckReport";
import { PartStatus } from "../models/Part";
import formatDateTime from "./formatDateTime";

export const STOCK_CHECK_REPORT_CSV_HEADERS = [
  "Tag number",
  "Part category",
  "Has images",
  "On eBay",
  "Part status",
  "Part age (days)",
  "Last stock check",
  "Part value",
  "MPN",
  "OEMPN",
];

export function stockCheckPartStatusLabel(status: PartStatus): string {
  return PartStatus[status] ?? String(status);
}

export function stockCheckReportCsvRow(item: IStockCheckReportItem): string[] {
  return [
    item.tagNumber ?? "",
    item.categoryName ?? "",
    item.hasImages ? "Yes" : "No",
    item.isOnEbay ? "Yes" : "No",
    stockCheckPartStatusLabel(item.partStatus),
    String(item.partAgeDays ?? 0),
    formatDateTime(item.previousStockChecked, DateTime.DATE_SHORT),
    item.partValue == null ? "" : item.partValue.toFixed(2),
    item.mpn ?? "",
    item.oemPn ?? "",
  ];
}
